import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useBrand } from "../../../../common/providers/brand/brand-context";

const CookieCat = ({ brand }) => {
  const notificationRequired = useBrand().getProp("Cookies.notify");
  const { locale } = useIntl();
  useEffect(() => {
    if (notificationRequired) {
      window.CookieCat?.init?.({
        app: "supernova",
        theme: brand.Theme.primary,
        locale: locale,
      });
    }
  }, [notificationRequired, brand, locale]);

  return null;
};

export default CookieCat;
